import type { OrderItem } from '@octave/contracts';
import { formatDate } from '@/lib/format';

interface LineItemMetadataProps {
  item: OrderItem;
}

export function LineItemMetadata({ item }: LineItemMetadataProps) {
  const metadata = item.metadata;
  if (metadata.type !== 'LINE') return null;

  const isPortability = metadata.orderNature === 'portability';

  return (
    <div className="mt-2 space-y-2">
      {/* User Information */}
      <div className="text-xs text-gray-500">
        Collaborateur:{' '}
        {`${metadata.firstName ?? ''} ${metadata.lastName ?? ''}`.trim()}
      </div>

      {/* Portability Information */}
      <div className="text-xs text-orange-700 bg-orange-50 p-2 rounded-md border border-orange-200 w-fit">
        <div className="font-medium mb-1">
          Portabilité: {isPortability ? 'Oui' : 'Non'}
        </div>

        {isPortability && (
          <>
            <div>Numéro à porter: {metadata.portedNumber}</div>
            <div>RIO: {metadata.rioNumber}</div>
            <div>
              Date de portabilité:{' '}
              {metadata.portabilityDate
                ? formatDate(metadata.portabilityDate)
                : null}
            </div>
          </>
        )}
      </div>

      {/* SIM Information */}
      <div className="text-xs text-gray-500">
        {metadata.physiqueOption === 'order' ? (
          <div>Nouvelle SIM à commander</div>
        ) : (
          <div>SIM en stock</div>
        )}
        <div>Type: {metadata.simType === 'esim' ? 'eSIM' : 'Physique'}</div>
      </div>

      {/* SIM Number for stock SIMs */}
      {metadata.physiqueOption === 'stock' && metadata.simNumber && (
        <div className="mt-2">
          <span className="text-xs bg-orange-50 text-orange-700 px-2 py-1 rounded-md border border-orange-200">
            SIM: {metadata.simNumber}
          </span>
        </div>
      )}

      {/* Site Information — snapshot pris à l'ajout au panier */}
      {metadata.siteName && (
        <div className="text-xs text-gray-500">
          <div>Centre de facturation: {metadata.siteName}</div>
        </div>
      )}
    </div>
  );
}
